import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { designSystem } from '@yola/ws-ui';

const { Box, Search } = designSystem;

function SearchBar({
  placeholder = '',
  sticky = false,
  borderless = false,
  defaultValue = '',
  onFocus = Function.prototype,
  onChange,
  onClear,
}) {
  const classes = classNames('ws-design-search-bar', {
    'ws-design-search-bar--sticky': sticky,
    'ws-design-search-bar--bottom-border': !borderless,
  });

  return (
    <div className={classes}>
      <Box
        paddingTop="spacing-2-xs"
        paddingBottom="spacing-2-xs"
        paddingLeft="spacing-m"
        paddingRight="spacing-m"
      >
        <Search
          placeholder={placeholder}
          defaultValue={defaultValue}
          transparent
          onChange={onChange}
          onClear={onClear}
          onFocus={onFocus}
        />
      </Box>
    </div>
  );
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  sticky: PropTypes.bool,
  borderless: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default SearchBar;
